import Vue from "vue";
import i18n from "../plugins/i18n";
import { mapToEmoji } from "../utils";

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("translate", function(value) {
  if (!value) return "";
  value = value.toString();
  return i18n.t(value);
});

Vue.filter("uppercase", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.toUpperCase();
});

Vue.filter("currency", function(value, currency) {
  if (!value) return "";
  return i18n.n(+value, currency || "EUR").toString();
});

Vue.filter("emoji", function(value) {
  if (!value) return "";
  return mapToEmoji(value);
});
